<template>
  <header class="aside-header" :class="{ 'is-collapsed': isCollapse }">
    <div class="aside-logo">
      <img :src="`https://btmswaterbg.sdbina.com/api/v1/projectLogo?token=${token}`" alt="">
    </div>
    <el-menu
      class="aside-menu"
      active-text-color="#1890ff"
      unique-opened
      router
      :collapse="isCollapse"
      :collapse-transition="false"
      :default-active="activePath"
    >
      <el-menu-item
        v-for="item in noChildren"
        :key="item.id"
        :index="normalizeIndex(item.path)"
        :class="{ active: isMenuActive(item.path) }"
        @click="saveNavState(normalizeIndex(item.path))"
      >
        <i :class="item.icon"></i>
        <span slot="title" class="menu-title">{{ item.authName }}</span>
      </el-menu-item>

      <el-submenu
        v-for="item in hasChilren"
        :key="item.id"
        :index="'/' + item.path"
      >
        <template slot="title">
          <i :class="item.icon"></i>
          <span class="menu-title">{{ item.authName }}</span>
        </template>
        <el-menu-item
          v-for="subItem in item.childern"
          :key="subItem.id"
          :index="normalizeIndex(subItem.path)"
          :class="{ active: isMenuActive(subItem.path) }"
          @click="saveNavState(normalizeIndex(subItem.path))"
        >
          <span class="menu-title">{{ subItem.authName }}</span>
        </el-menu-item>
      </el-submenu>
    </el-menu>
  </header>
</template>
<script>
import { DEFAULT_MENU_LIST, mergeMenuConfig } from '@/utils/menuConfig'

export default {
  props: {
    isCollapse: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      activePath: '',
      token: null,
      menulist: JSON.parse(JSON.stringify(DEFAULT_MENU_LIST))
    }
  },
  created () {
    this.token = this.$store.state.print.goodsForeNo.token
    if (this.$store.state.print.menuConfig && this.$store.state.print.menuConfig.length) {
      this.menulist = mergeMenuConfig(this.$store.state.print.menuConfig)
    }
    this.syncActivePath()
    this.fetchMenuConfig()
  },
  watch: {
    $route () {
      this.syncActivePath()
    },
    '$i18n.locale': {
      handler () {
        this.$forceUpdate()
      },
      immediate: true
    },
    '$store.state.print.menuConfig': {
      handler (val) {
        if (val && val.length) {
          this.menulist = mergeMenuConfig(val)
        }
      },
      deep: true
    },
    isCollapse () {
      this.$nextTick(() => this.patchMenuTooltips())
    }
  },
  mounted () {
    this.$nextTick(() => this.patchMenuTooltips())
  },
  updated () {
    this.$nextTick(() => this.patchMenuTooltips())
  },
  methods: {
    normalizeIndex (path) {
      if (!path) return '/'
      return String(path).startsWith('/') ? path : '/' + path
    },
    // 折叠态悬停 Tooltip 延迟 200ms（覆盖 el-menu 内置 Tooltip）
    patchMenuTooltips () {
      if (!this.isCollapse) return
      const walk = (vm) => {
        if (!vm) return
        if (vm.$options && vm.$options.name === 'ElTooltip') {
          vm.openDelay = 200
        }
        ;(vm.$children || []).forEach(walk)
      }
      walk(this)
    },
    fetchMenuConfig () {
      const params = { token: this.token }
      this.$api.lonig.getMenuConfig(params).then(res => {
        if (res && res.data && res.data.status === 'success' && res.data.data) {
          const config = mergeMenuConfig(res.data.data)
          if (config && config.length) {
            this.menulist = config
            this.$store.commit('print/STORE_MENU_CONFIG', config)
          }
        }
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.error('获取菜单配置失败', err)
      })
    },
    saveNavState (activePath) {
      window.sessionStorage.setItem('activePath', activePath)
      this.activePath = activePath
    },
    syncActivePath () {
      const path = this.$route.path || ''
      const stored = window.sessionStorage.getItem('activePath')
      this.activePath = path || stored || ''
      if (path) {
        window.sessionStorage.setItem('activePath', path)
      }
    },
    isMenuActive (menuPath) {
      if (!menuPath) return false
      const current = (this.$route.path || '').replace(/^\//, '')
      const target = String(menuPath).replace(/^\//, '')
      return current === target || current.startsWith(target + '/')
    }
  },
  computed: {
    noChildren () {
      return this.menulist.filter((item) => !item.childern)
    },
    hasChilren () {
      return this.menulist.filter((item) => item.childern)
    }
  }
}
</script>
<style lang="less">
.aside-header {
  height: 100%;
  border-right: 3px solid #744DFE; /* 5px 颜色 */
  box-sizing: border-box; /* 防止宽度被撑大 */
  .aside-logo {
    padding: 20px 0 10px;
    overflow: hidden;
    transition: all 0.3s ease;

    img {
      width: 60%;
      max-width: 120px;
      height: auto;
      max-height: 100px;
      object-fit: contain;
      transition: width 0.3s ease, height 0.3s ease;
    }
  }

  &.is-collapsed {
    .aside-logo {
      padding: 16px 0 8px;

      img {
        width: 36px;
        height: 36px;
      }
    }
  }

  .aside-menu {
    width: 100%;
    background-color: #F5F9FC;
    color: #656d92;
    cursor: pointer;
    border: 0;

    &:not(.el-menu--collapse) {
      width: 100%;
    }

    .menu-title {
      font-size: 1rem;
      letter-spacing: 1px;
    }

    .iconfont {
      margin-right: 20px;
      color: inherit;
      width: 24px;
      text-align: center;
      vertical-align: middle;
    }

    .iconfont.icon-caiwubaobiao {
      font-size: 26px;
    }

    .iconfont.icon-xiangmushouye1 {
      font-size: 22px;
    }

    &.el-menu--collapse {
      // width: 60px;

      .iconfont {
        margin-right: 0;
      }

      .el-submenu__icon-arrow {
        display: none;
      }

      > .el-menu-item,
      > .el-submenu > .el-submenu__title {
        text-align: center;
      }
    }

    .el-menu-item,
    .el-submenu__title {
      position: relative;
      height: 56px;
      line-height: 56px;
      color: #656d92;
    }

    .el-menu-item.is-active,
    .el-menu-item.active {
      background-color: #f0f5ff !important;
      color: #987AFF !important;
      border-radius: 0;

      span,
      .menu-title,
      i,
      .iconfont {
        color: #987AFF !important;
      }

      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 3px;
        background-color: #987AFF;
        z-index: 1;
      }
    }
  }
}
.aside-menu {
  /* 覆盖 Element UI 默认的 min-width: 200px */
  .el-submenu .el-menu-item {
    min-width: 0 !important; /* 或者 min-width: auto !important; */
  }
}
</style>
